import { createAction, props } from '@ngrx/store';
import { FlexLayoutMedia } from './device.reducer';

export const initDeviceState = createAction('[Device State] Init');

export const setDeviceWidthHeight = createAction(
  '[Device State] Set Device Width and Height',
  props<{ deviceWidth: number; deviceHeight: number }>()
);

export const setCurrentDevice = createAction(
  '[Device State] Set Current Device',
  props<{ isMobile: boolean; isDesktop: boolean }>()
);

export const flexLayoutMediaObserverEmitted = createAction(
  '[Device State] Flex Layout Media Observer Emitted',
  props<{ flexLayoutMedia: FlexLayoutMedia }>()
);
